import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import SummaryApi from "../../common";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import the CSS file for toast styles

const AddCourses = () => {
  const [formData, setFormData] = useState({
    department: "",
    courseName: "",
    credits: "",
    description: "",
    maxStudents: "",
    courseLevel: "",
    courseType: "",
    tuitionFee: "",
    courseImage: null,
    isActive: true,
  });

  const [departments, setDepartments] = useState([]); // State to store departments

  // Fetch departments when component mounts
  useEffect(() => {
    fetch(SummaryApi.getAllDepartment.url)
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          setDepartments(data.data); // Set the departments in state
        }
      })
      .catch((error) => console.error("Error fetching departments:", error));
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData({
      ...formData,
      [name]:
        type === "checkbox" ? checked : type === "file" ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
    const formDataToSend = new FormData();
    formDataToSend.append("department_id", formData.department);
    formDataToSend.append("course_name", formData.courseName);
    formDataToSend.append("credits", formData.credits);
    formDataToSend.append("description", formData.description);
    formDataToSend.append("max_students", formData.maxStudents);
    formDataToSend.append("course_level", formData.courseLevel);
    formDataToSend.append("course_type", formData.courseType);
    formDataToSend.append("tuition_fee", formData.tuitionFee);
    formDataToSend.append("course_image", formData.courseImage);
    formDataToSend.append("is_active", formData.isActive ? 1 : 0);
  
    // Send the data using fetch
    fetch(SummaryApi.createCourse.url, {
      method: "POST",
      body: formDataToSend,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Course Created:", data);
        if (data.status) {
          // Display success toast message
          toast.success("Course created successfully!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          // Reset the form fields after success
          handleReset();
        } else {
          toast.error("Failed to create course. Please try again.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch((error) => {
        console.error("Error creating course:", error);
        toast.error("Error creating course. Please try again.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };
  
  

  const handleReset = () => {
    setFormData({
      department: "",
      courseName: "",
      credits: "",
      description: "",
      maxStudents: "",
      courseLevel: "",
      courseType: "",
      tuitionFee: "",
      courseImage: null, // Reset the image field
      isActive: true,
    });
  };
  

  return (
    <div className="">
      <h1 className="text-2xl sm:text-3xl lg:text-4xl font-semibold mb-4 text-center sm:text-left">
        Courses
      </h1>
      {/* Toast container to display notifications */}
      <ToastContainer />
      <nav className="text-gray-600 mb-4">
        <ol className="flex flex-wrap items-center space-x-2 text-sm sm:text-base">
          <li>
            <Link to="/dashboard" className="hover:text-[#ffa404]">
              Home
            </Link>
          </li>
          <li className="text-[#ffa404]">
            <MdKeyboardArrowRight size={25} />
          </li>
          <li className="text-[#ffa404]">
            <Link to="/AddCourses" className="hover:text-[#ffa404]">
              Add New Course
            </Link>
          </li>
        </ol>
      </nav>

      <div className="bg-white shadow-md rounded-lg p-6 mt-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center sm:text-left">
          Add New Course
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Department Dropdown */}
            <div>
              <label className="block text-[16px] font-medium text-gray-500">
                Department*
              </label>
              <select
                name="department"
                value={formData.department}
                onChange={handleChange}
                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                required
              >
                <option value="">Select Department</option>
                {departments.map((department) => (
                  <option
                    key={department.department_id}
                    value={department.department_id}
                  >
                    {department.department_name}
                  </option>
                ))}
              </select>
            </div>

            {/* Course Name */}
            <div>
              <label className="block text-[16px] font-medium text-gray-500">
                Course Name*
              </label>
              <input
                type="text"
                name="courseName"
                value={formData.courseName}
                onChange={handleChange}
                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                required
              />
            </div>

            {/* Credits */}
            <div>
              <label className="block text-[16px] font-medium text-gray-500">
                Credits*
              </label>
              <select
                name="credits"
                value={formData.credits}
                onChange={handleChange}
                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                required
              >
                <option value="">Select Credits</option>
                <option value="1">1 </option>
                <option value="2">2 </option>
                <option value="3">3 </option>
              </select>
            </div>

            {/* Max Students */}
            <div>
              <label className="block text-[16px] font-medium text-gray-500">
                Max Students*
              </label>
              <input
                type="number"
                name="maxStudents"
                value={formData.maxStudents}
                onChange={handleChange}
                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                required
              />
            </div>

            {/* Course Level Dropdown */}
            <div>
              <label className="block text-[16px] font-medium text-gray-500">
                Course Level*
              </label>
              <select
                name="courseLevel"
                value={formData.courseLevel}
                onChange={handleChange}
                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                required
              >
                <option value="">Select Course Level</option>
                <option value="UG">Undergraduate (UG)</option>
                <option value="PG">Postgraduate (PG)</option>
              </select>
            </div>

            {/* Course Type Dropdown */}
            <div>
              <label className="block text-[16px] font-medium text-gray-500">
                Course Type*
              </label>
              <select
                name="courseType"
                value={formData.courseType}
                onChange={handleChange}
                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                required
              >
                <option value="">Select Course Type</option>
                <option value="Lecture">Lecture</option>
                <option value="Lab">Lab</option>
                <option value="Seminar">Seminar</option>
              </select>
            </div>

            {/* Tuition Fee */}
            <div>
              <label className="block text-[16px] font-medium text-gray-500">
                Tuition Fee*
              </label>
              <input
                type="number"
                name="tuitionFee"
                value={formData.tuitionFee}
                onChange={handleChange}
                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                required
              />
            </div>

            {/* Course Image Upload */}
            <div className="col-span-1 sm:col-span-1 lg:col-span-1">
              <label className="block text-[16px] font-medium text-gray-500">
                Course Image*
              </label>
              <input
                type="file"
                name="courseImage"
                onChange={handleChange}
                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                accept="image/*"
                required
              />
            </div>

            {/* Description */}
            <div className="col-span-1 sm:col-span-2 lg:col-span-2">
              <label className="block text-[16px] font-medium text-gray-500">
                Description*
              </label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                required
              ></textarea>
            </div>

            {/* Is Active Checkbox */}
            <div className="col-span-1 sm:col-span-2 lg:col-span-2 flex">
              <input
                type="checkbox"
                name="isActive"
                checked={formData.isActive}
                onChange={handleChange}
                className="mr-1"
              />
              <label className="block text-[16px] font-medium text-gray-500">
                Is Active
              </label>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row space-x-0 sm:space-x-4 mt-4">
            <button
              type="submit"
              className="p-4 bg-[#ffa404] text-white rounded-md hover:bg-[#e89d02] flex items-center justify-center"
            >
              Save
            </button>
            <button
              type="button"
              onClick={handleReset}
              className="p-4 bg-gray-300 text-black rounded-md hover:bg-gray-400 flex items-center justify-center mt-4 sm:mt-0"
            >
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCourses;
